import { styled } from 'styled-components';

const LoaderWrapper = styled.div`
  height: 10rem;
`;

export { LoaderWrapper };
